'use client'

import { List, MapPin, Package } from 'lucide-react'
import Link from 'next/link'
import { getReturnPolicyUrl } from '@/lib/return-policy-urls'
import { Locale } from '@/lib/i18n'

const NavigationBar = ({
	dictionary,
	locale,
	visibleItems = ['back-button', 'store-index', 'return-to-locator', 'return-policy'],
}: {
	dictionary: Record<string, string>
	locale: Locale
	visibleItems?: string[]
}) => {
	const items = [
		{
			id: 'store-index',
			condition: visibleItems.includes('store-index'),
			component: () => (
				<Link
					href={`/${locale}/`}
					className="text-sm text-gray-600 hover:text-gray-900 hover:bg-gray-200 rounded-md p-2 transition-colors flex flex-row items-center gap-2 flex-nowrap"
				>
					<List className="w-3 h-3" />
					{dictionary['store-index']}
				</Link>
			),
		},
		{
			id: 'return-to-locator',
			condition: visibleItems.includes('return-to-locator'),
			component: () => (
				<Link
					href={`/${locale}/locator`}
					className="text-sm text-gray-600 hover:bg-gray-200 rounded-md p-2  hover:text-gray-900 transition-colors flex flex-row items-center gap-2 flex-nowrap"
				>
					<MapPin className="w-3 h-3" />
					{dictionary['return-to-locator']}
				</Link>
			),
		},
		{
			id: 'return-policy',
			condition: visibleItems.includes('return-policy'),
			component: () => (
				<Link
					href={getReturnPolicyUrl(locale)}
					className="text-sm text-gray-600 hover:bg-gray-200 rounded-md p-2  hover:text-gray-900 transition-colors flex flex-row items-center gap-2 flex-nowrap"
					target="_blank"
				>
					<Package className="w-3 h-3" />
					{dictionary['view-return-policy']}
				</Link>
			),
		},
	].filter((item) => item.condition)

	return (
		<div className="flex flex-row items-center gap-2 p-2 w-full">
			{items.map((item, index) => (
				<div className={`${index > 0 ? 'border-l-1 border-gray-300 pl-2' : ''}`} key={item.id}>
					{item.component()}
				</div>
			))}
		</div>
	)
}

export default NavigationBar
